import { createContext, ReactNode, useContext } from 'react';

import { getRefundDataForWebStorage } from '@/components/tax-refund/common/utils/refund-data';

export type BusinessType = 'indis' | 'corps';
interface BankAccountContextType {
  businessType: BusinessType;
  refundId: string;
  refundAmountTotal: number;
  refundAmount: number;
  bizName: string;
}

const BankAccountContext = createContext<BankAccountContextType>({} as BankAccountContextType);

export const useBankAccountContext = () => useContext<BankAccountContextType>(BankAccountContext);

export const BankAccountContextProvider = ({ children, businessType }: { children: ReactNode; businessType: BankAccountContextType['businessType'] }) => {
  const data = getRefundDataForWebStorage(businessType);

  return (
    <BankAccountContext.Provider
      value={{
        businessType,
        refundId: (businessType === 'corps' ? data.corps?.refundId : data.indis?.refundId || data.indis.tritxRefundInfo?.refundId) || '',
        bizName: (businessType === 'corps' ? data.corps?.bizName : data.indis?.bizName || data.indis?.tritxRefundInfo?.businessInfo?.taxpayerName) || '',
        refundAmountTotal:
          businessType === 'corps'
            ? Number(data.corps?.refundAmount ?? 0)
            : Number(data.indis?.refundAmount ?? 0) + Number(data.indis?.tritxRefundInfo?.refundAmount ?? 0),
        refundAmount: businessType === 'corps' ? Number(data.corps?.refundAmount ?? 0) : Number(data.indis?.refundAmount ?? 0)
      }}
    >
      {children}
    </BankAccountContext.Provider>
  );
};
